// @ts-nocheck
class GiftAddOns extends HTMLElement {
  constructor() {
    super();
    this.product_id = Number(this.getAttribute('data-giftWrap-product-id'));
    this.variant_id = Number(this.getAttribute('data-giftWrap-variant-id'));
    this.lineItem_id = Number(this.getAttribute('data-lineItem-id'));
    this.lineItem_key = this.getAttribute('data-lineItem-key');
    this.lineItem_title = this.getAttribute('data-lineItem-title');
    this.lineItem_qty = Number(this.getAttribute('data-lineItem-qty'));
    this.lineItem_variant_id = this.getAttribute('data-lineItem-variant-id');
    this.complimentaryAddOns = this.parentElement?.querySelector('.complimentary-add-ons');
    this.complimentaryAddOnsVariantId = Number(this.complimentaryAddOns?.getAttribute('data-complimentary-variant-id'));
    this.GiftWrapSelected = this.getAttribute('data-giftWrap-selected');
    this.existingGiftWrapNote = this.getAttribute('data-giftWrap-note');
    this.giftWrapNoteElement = this.parentElement?.querySelector('#giftwrapNote');
    this.isTyping = false; // Flag to indicate if the user is typing

    if (this.existingGiftWrapNote.length > 0) {
      this.giftWrapNoteElement.value = this.existingGiftWrapNote;
    }
    if (this.GiftWrapSelected === 'Yes') {
      this.classList.remove('unchecked');
      this.classList.add('checked');
    }
    
    const targetedComplimentaryNoteItems = document.querySelectorAll(`.line-item[data-lineItem-variant-id="${this.complimentaryAddOnsVariantId}"]`);

    if (targetedComplimentaryNoteItems.length > 0) {
      const targetedComplimentaryNoteLineItem = Array.from(targetedComplimentaryNoteItems)?.filter(lineItem => {
        const targetedItemTitle = this.handleizeString(lineItem.dataset.targetProduct);
        const currentItemTitle = this.handleizeString(this.lineItem_title);
        return targetedItemTitle === currentItemTitle;
      });
      this.targetedComplimentaryNoteItemKey = targetedComplimentaryNoteLineItem[0]?.getAttribute('data-lineItem-key');
    }

    const targetedGiftWrapItems = document.querySelectorAll(`.line-item[data-lineItem-variant-id="${this.variant_id}"]`);

    if (targetedGiftWrapItems.length > 0) {
      const targetedGiftWrapLineItem = Array.from(targetedGiftWrapItems)?.filter(lineItem => {
        const targetedItemTitle = this.handleizeString(lineItem.dataset.targetProduct);
        const currentItemTitle = this.handleizeString(this.lineItem_title);
        return targetedItemTitle === currentItemTitle;
      });
      this.targetedGiftWrapItemKey = targetedGiftWrapLineItem[0]?.getAttribute('data-lineItem-key');
    }
  }

  connectedCallback() {
    try {
      this.bindEvents();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  bindEvents() {
    try {
      this.addEventListener('click', this.debounce(this.handleClick.bind(this), 5));
      this.giftWrapNoteElement.addEventListener('blur', this.debounce(this.UpdateLineItem.bind(this), 5));
      this.giftWrapNoteElement.addEventListener('input', this.handleTyping.bind(this));
    } catch (error) {
      console.error('error on updating real time:', error);
    }
  }

  async handleClick(e) {
    if (!this.classList.contains('unchecked') && this.classList.contains('checked')) {
      this.classList.remove('checked');
      this.classList.add('unchecked');
      this.checked = false;
      this.UpdateCartOnDeselect();
    } else if (this.classList.contains('unchecked') && !this.classList.contains('checked')) {
      this.classList.remove('unchecked');
      this.classList.add('checked');
      this.complimentaryAddOns?.classList.remove('checked');
      this.complimentaryAddOns?.classList.add('unchecked');
      this.checked = true;
      this.UpdateCartOnSelect();
    }
  }

  handleTyping() {
    clearTimeout(this.typingTimer); // Clear the timer if the user is still typing
    this.isTyping = true; // Set typing flag to true
  }

  handleizeString(str) {
    return str.trim().toLowerCase().replace(/\s+/g, '-').replace(/-+/g, '-');
  }

  async AddToCart(payload) {
    await fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.text())
      .catch((err) => {
        console.error(err);
      });
  }

  async RemoveFromCart(payload) {
    await fetch(`/cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.text())
      .catch((err) => {
        console.error(err);
      });
  }

  async UpdateLineItemProperties(payload) {
    await fetch(`/cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.text())
      .catch((err) => {
        console.error(err);
      });
  }

  async UpdateCartOnSelect() {
    // Add Gift Wrap to the cart with properties
    await this.AddToCart({
      "items": [
        {
          "id": this.variant_id,
          "quantity": 1,
          "properties": {
            "Product id": this.product_id,
            "For": this.lineItem_title,
          }
        }
      ]
    });

    if (this.targetedComplimentaryNoteItemKey) {
      // Remove Complimentary Add-Ons from the cart
      await this.RemoveFromCart({
        updates: {
          [this.targetedComplimentaryNoteItemKey]: 0,
        },
      });
    }

    // Update Current Line Item Properties by indicating that Gift Wrap is selected
    await this.UpdateLineItemProperties({
      'id': this.lineItem_variant_id,
      'quantity': this.lineItem_qty,
      'properties': {
        'Gift Wrap Selected': 'Yes',
      },
    });

    // Set a timer to reload the page unless typing starts
    this.resetTimerAndReload();
  }
  
  async UpdateCartOnDeselect () {
    if (this.targetedGiftWrapItemKey) {
      // Remove Gift Wrap Add-Ons from the cart
      await this.RemoveFromCart({
        updates: {
          [this.targetedGiftWrapItemKey]: 0,
        },
      });
    }

    // Add Current Item again without properties
    await this.AddToCart({
      "items": [
        {
          "id": this.lineItem_variant_id,
          "quantity": this.lineItem_qty,
        }
      ]
    });

    // Remove Current Item with the properties from the cart
    await this.RemoveFromCart({
      updates: {
        [this.lineItem_key]: 0,
      },
    });
    
    // Set a timer to reload the page unless typing starts
    this.resetTimerAndReload(800);
  }

  async removeMainProductWithAddOns (e) {
    if (this.targetedGiftWrapItemKey) {
      // Remove Gift Wrap Add-Ons from the cart
      await this.RemoveFromCart({
        updates: {
          [this.targetedGiftWrapItemKey]: 0,
        },
      });
    }

    e.closest(".cart-prod-wrapper").querySelector("complimentary-add-ons").removeMainProdComplementary();
  }

  resetTimerAndReload(delay) {
    const doneTypingInterval = delay || 2000;
    clearTimeout(this.typingTimer); // Clear the timer if the user is still typing
    this.typingTimer = setTimeout(() => {
      if (!this.isTyping) {
        this.reloadPage();
      }
    }, doneTypingInterval); // Set a new timer
  }

  async UpdateLineItem() {
    this.isTyping = false; // Reset typing flag
    const newNote = this.giftWrapNoteElement.value;

    // Check if the note is not empty and has changed
    if (newNote !== this.existingGiftWrapNote && newNote.trim() !== '') {
      // Update Line Item Properties by indicating that Gift Wrap is selected and update gift notes
      await this.UpdateLineItemProperties({
        'id': this.lineItem_variant_id,
        'quantity': this.lineItem_qty,
        'properties': {
          'Gift Wrap Selected': 'Yes',
          'Gift Wrap Note': this.giftWrapNoteElement.value,
        },
      });
      // Reload the page after a short delay
      this.resetTimerAndReload(1000);
    }

  }

  reloadPage() {
    window.location.reload();
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define('gift-add-ons', GiftAddOns);


class ComplimentaryAddOns extends HTMLElement {
  constructor() {
    super();
    this.product_id = Number(this.getAttribute('data-complimentary-product-id'));
    this.variant_id = Number(this.getAttribute('data-complimentary-variant-id'));
    this.lineItem_id = Number(this.getAttribute('data-lineItem-id'));
    this.lineItem_title = this.getAttribute('data-lineItem-title');
    this.lineItem_key = this.getAttribute('data-lineItem-key');
    this.lineItem_qty = Number(this.getAttribute('data-lineItem-qty'));
    this.lineItem_variant_id = this.getAttribute('data-lineItem-variant-id');
    this.giftAddOns = this.parentElement?.querySelector('.gift-add-ons');
    this.giftAddOnsVariantId = Number(this.giftAddOns?.getAttribute('data-giftWrap-variant-id'));
    this.ComplimentWrapSelected = this.getAttribute('data-compliment-wrap-selected');
    this.existingComplimentNote = this.getAttribute('data-compliment-note');
    this.complimentNoteElement = this.parentElement?.querySelector('#complimentary_Note');
    this.isTyping = false;

    if (this.existingComplimentNote.length > 0) {
      this.complimentNoteElement.value = this.existingComplimentNote;
    }
    if (this.ComplimentWrapSelected === 'No' && this.existingComplimentNote.length > 0) {
      this.classList.remove('unchecked');
      this.classList.add('checked');
    }
    
    const targetedGiftWrapItems = document.querySelectorAll(`.line-item[data-lineItem-variant-id="${this.giftAddOnsVariantId}"]`);

    if (targetedGiftWrapItems.length > 0) {
      const targetedGiftWrapLineItem = Array.from(targetedGiftWrapItems)?.filter(lineItem => {
        const targetedItemTitle = this.handleizeString(lineItem.dataset.targetProduct);
        const currentItemTitle = this.handleizeString(this.lineItem_title);
        return targetedItemTitle === currentItemTitle;
      });
      this.targetedGiftWrapItemKey = targetedGiftWrapLineItem[0]?.getAttribute('data-lineItem-key');
    }
    
    const targetedComplimentaryNoteItems = document.querySelectorAll(`.line-item[data-lineItem-variant-id="${this.variant_id}"]`);

    if (targetedComplimentaryNoteItems.length > 0) {
      const targetedComplimentaryNoteLineItem = Array.from(targetedComplimentaryNoteItems)?.filter(lineItem => {
        const targetedItemTitle = this.handleizeString(lineItem.dataset.targetProduct);
        const currentItemTitle = this.handleizeString(this.lineItem_title);
        return targetedItemTitle === currentItemTitle;
      });
      this.targetedComplimentaryNoteItemKey = targetedComplimentaryNoteLineItem[0]?.getAttribute('data-lineItem-key');
    }
  }

  connectedCallback() {
    try {
      this.bindEvents();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  bindEvents() {
    try {

      this.addEventListener('click', this.debounce(this.handleClick.bind(this), 5));
      this.complimentNoteElement.addEventListener('blur', this.debounce(this.UpdateLineItem.bind(this), 5));
      this.complimentNoteElement.addEventListener('input', this.handleTyping.bind(this));
    } catch (error) {
      console.error('error on updating real time:', error);
    }
  }

  handleClick(e) {
    if (!this.classList.contains('unchecked') && this.classList.contains('checked')) {
      this.classList.remove('checked');
      this.classList.add('unchecked');
      this.checked = false;
      this.UpdateCartOnDeselect();
    } else if (this.classList.contains('unchecked') && !this.classList.contains('checked')) {
      this.classList.remove('unchecked');
      this.classList.add('checked');
      this.giftAddOns?.classList.remove('checked');
      this.giftAddOns?.classList.add('unchecked');
      this.checked = true;
      this.UpdateCartOnSelect();
    }
  }

  handleizeString(str) {
    return str.trim().toLowerCase().replace(/\s+/g, '-').replace(/-+/g, '-');
  }

  handleTyping() {
    clearTimeout(this.typingTimer); // Clear the timer if the user is still typing
    this.isTyping = true; // Set typing flag to true
  }

  async AddToCart(payload) {
    await fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.text())
      .catch((err) => {
        console.error(err);
      });
  }

  async RemoveFromCart(payload) {
    await fetch(`/cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.text())
      .catch((err) => {
        console.error(err);
      });
  }

  async UpdateLineItemProperties(payload) {
    await fetch(`/cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.text())
      .catch((err) => {
        console.error(err);
      });
  }

  async UpdateCartOnDeselect () {
    // No Compliment Note to remove
    if (!this.targetedComplimentaryNoteItemKey) {
      return;
    }
    // Remove Complimentary Add-Ons from the cart
    await this.RemoveFromCart({
      updates: {
        [this.targetedComplimentaryNoteItemKey]: 0,
      },
    });
    

    // Add Current Item again without properties
    await this.AddToCart({
      "items": [
        {
          "id": this.lineItem_variant_id,
          "quantity": this.lineItem_qty,
        }
      ]
    });

    // Remove Current Item from the cart with the properties
    await this.RemoveFromCart({
      updates: {
        [this.lineItem_key]: 0,
      },
    });

    // Set a timer to reload the page unless typing starts
    this.resetTimerAndReload(800);
  }
  

  async removeMainProdComplementary () {
    // No Compliment Note to remove
    if (this.targetedComplimentaryNoteItemKey) {
      // Remove Complimentary Add-Ons from the cart
      await this.RemoveFromCart({
        updates: {
          [this.targetedComplimentaryNoteItemKey]: 0,
        },
      });
    }
    
    // Remove Current Item from the cart with the properties
    await this.RemoveFromCart({
      updates: {
        [this.lineItem_key]: 0,
      },
    });

    // Set a timer to reload the page unless typing starts
    this.resetTimerAndReload(800);
  }

  async UpdateCartOnSelect() {
    this.complimentNoteElement.focus();

    if (this.targetedGiftWrapItemKey) {
        // Remove Gift Wrap Add-Ons from the cart
        await this.RemoveFromCart({
          updates: {
            [this.targetedGiftWrapItemKey]: 0,
          },
        });
      }

    // Update Current Line Item Properties by indicating that Complimentary note is selected
    // await this.UpdateLineItemProperties({
    //   'id': this.lineItem_variant_id,
    //   'properties': {
    //     'Compliment Wrap Selected': 'No',
    //   },
    // });

    // Set a timer to reload the page unless typing starts
    // this.resetTimerAndReload();
  }

 

  resetTimerAndReload(delay) {
    const doneTypingInterval = delay || 2000;
    clearTimeout(this.typingTimer); // Clear the timer if the user is still typing
    this.typingTimer = setTimeout(() => {
      if (!this.isTyping) {
        this.reloadPage();
      }
    }, doneTypingInterval); // Set a new timer
  }

  async UpdateLineItem() {
    this.isTyping = false; // Reset typing flag
    const newNote = this.complimentNoteElement.value;

    if (newNote.trim() === '') {
      this.complimentNoteElement.classList.add('error');
      // alert('Complimentary Note cannot be empty');
      return;
    }

     // Check if the note is not empty and has changed
    if (newNote !== this.existingComplimentNote && newNote.trim() !== '') {
      this.complimentNoteElement.classList.remove('error');
      // Add complimentary note to the cart with properties
      await this.AddToCart({
        "items": [
          {
            "id": this.variant_id,
            "quantity": 1,
            "properties": {
              "Product id": this.product_id,
              "For": this.lineItem_title,
            }
          }
        ]
      });

      // Update Line Item Properties by indicating that Gift Wrap is selected and update gift notes
      await this.UpdateLineItemProperties({
        'id': this.lineItem_variant_id,
        'quantity': this.lineItem_qty,
        'properties': {
          'Compliment Wrap Selected': 'No',
          'Compliment Wrap Note': this.complimentNoteElement.value,
        },
      });
      
      // Reload the page after a short delay
      this.resetTimerAndReload(1000);
    }
  }

  reloadPage() {
    window.location.reload();
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define('complimentary-add-ons', ComplimentaryAddOns);

class CartLineRemove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    const event = new CustomEvent('cart-line-remove', {
      bubbles: true,
      cancelable: true,
      detail: {
        baseEvent: this.getAttribute('data-base-event'),
      },
    });
    this.dispatchEvent(event);
  }
}

customElements.define('cart-line-remove', CartLineRemove);

function RemoveLineItemPropertiesOnAddonsRemove(e) {
  const eventType = e.detail.baseEvent;
  if (eventType === 'gift-wrap-remove' || eventType === 'complimentary-note-remove') {
    const parentLineItemTitle = e.target.attributes["data-parent-line-item-title"].value.replace(/(['"])/g, '\\$1');
    const parentLineItem = document.querySelector(`gift-add-ons[data-lineitem-title="${parentLineItemTitle}"]`);
    // console.log('parentLineItem:', parentLineItem);
    parentLineItem.UpdateCartOnDeselect();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('cart-line-remove', RemoveLineItemPropertiesOnAddonsRemove.bind(this));
});



function mainCartProd(e) {
  // e.preventDefault();
  // console.log("e clicked", e);
  console.log(e.closest(".cart-prod-wrapper").querySelector("complimentary-add-ons"));
  e.closest(".cart-prod-wrapper").querySelector("gift-add-ons").removeMainProductWithAddOns(e);
  
}

